<template>
    <div class="answer-module">
        <ModuleTitle title="剑道问心"></ModuleTitle>
        <div class="answer-title qm-special-font">
            <p class="title-text">吾乃青莲一缕魂，诗酒剑术略通几分。</p>
            <p class="title-text">见你身负灵根道心澄澈，可愿接我三问？</p>
            <div class="g-flex-center-center">
                <p class="title-text title-text-top">若你答对了，这</p>
                <p class="title-text title-text-top title-text-mark" @click="onShowGourd">太白酒葫芦</p>
                <div class="gourd-img" @click="onShowGourd"></div>
            </div>
            <p class="title-text title-text-top">便赠与你了，如何？</p>
        </div>
        <div class="list-item zindex2" v-for="(item, index) in questionList" :key="index">
            <p class="list-item-title">{{ index + 1 }}. {{ item.question }}</p>
            <div class="option-list g-flex g-flex-wrap">
                <div class="option-item g-flex-start-center" :class="getOptionClass(item, key)" v-for="(key, index2) in questionKeys" :key="key" @click="onSelect(item, key, index)">
                    <div class="option-item-sort">
                        {{ sortText[index2] }}
                    </div>
                    <p class="option-item-text">{{ item[`option_${key}`] }}</p>
                    <div class="option-item-icon" :class="getOptionIconClass(item, key)"></div>
                </div>
            </div>
        </div>
        <div class="answer-btn zindex2 button-1 g-flex-center-center" @click="onSubmit">{{ isSubmite ? '今日已提交' : '提交' }}</div>
        <div class="answer-tip zindex2" v-if="canGetGourd">
            <p>剑仙神念需以日月精华温养，一日仅能苏醒一次。</p>
            <p>请道友慎重提交！</p>
        </div>
        <div class="answer-tip zindex2" v-else>
            <p>已集满法宝【太白酒葫芦】碎片，后续答题不再获得额外奖励</p>
        </div>
        <img class="answer-bg" src="@/assets/images/bg/bg_img_5@3x.jpg" alt="" />
    </div>
</template>
<script lang="ts" setup>
import { computed, ref, getCurrentInstance } from 'vue';
import ModuleTitle from '../module-title/index.vue';
import { apiQuestionList, apiQuestionSubmit } from '@/http/api';
import { schemaSingle, openLogin, jsbReportV3 } from '@q-front-npm/jsbridge';
import { useStore } from '@/store';
const instance = getCurrentInstance();
const store = useStore();
const emits = defineEmits(['loadResource']);
const sortText: Record<number, string> = {
    0: '甲',
    1: '乙',
    2: '丙',
    3: '丁',
};

const canGetGourd = computed(() => {
    const { user_fragment_num, need_fragment_num, status, } = store.magicWeapon;
    return status === '0' && user_fragment_num < need_fragment_num;
});
const questionKeys = ['one', 'two', 'three', 'four'];
const questionList = ref<Record<string, any>[]>([]);

let selectKeyList: string[] = [];
const onSelect = (item: Record<string, any>, key: string, index: number) => {
    if (isSubmite.value) {
        return;
    }
    console.log(item, key);
    const optionKey = `option_${key}`;
    selectKeyList[index] = '';
    item.history_answer = optionKey;
    selectKeyList[index] = optionKey;
};
const saClick = (result: string) => {
    jsbReportV3('moon_btn_button_click', { btn_wenan: '提交', return_result: result, });
};
const isSubmite = ref(false);
const onSubmit = async() => {
    if (!store.indexData.isLogin) {
        openLogin();
        return;
    }
    if (isSubmite.value) {
        return;
    }
    const noAnswer = selectKeyList.some((item) => !item);
    if (noAnswer) {
        instance!.proxy.$toast('请完成所有题目');
        return;
    }
    const params = {
        questionOne: selectKeyList[0],
        questionTwo: selectKeyList[1],
        questionThree: selectKeyList[2],
    };
    const res = await apiQuestionSubmit(params);
    // status : 1 正确 2 错误 3 已集齐
    const { status, magic_weapon, magic_weapon_info, } = res;
    store.setIsAnswered(true);
    if (canGetGourd.value) {
        store.setPopStatus(status === '2' ? 'noget' : 'get', true);
        store.setPopData({
            reward_img_url: magic_weapon.icon,
            reward_title: magic_weapon.title,
            reward_btn_title: '查看详情',
            isGourd: true,
        });
        store.setMagicWeapon(magic_weapon_info);
        if (status === '3') {
            emits('loadResource');
        }
    }
    getQuestionList();
    saClick(status === '2' ? '错误' : '正确');
};

const getOptionClass = (item: Record<string, any>, key: string) => {
    const classes: Record<string, boolean> = {};
    if (isSubmite.value) {
        const isRight = item.answer === `option_${key}`;
        classes['option-item-right'] = isRight;
        classes['option-item-error'] = item.history_answer === `option_${key}` && !isRight;
    } else {
        classes['option-item-select'] = item.history_answer === `option_${key}`;
    }
    return classes;
};
const getOptionIconClass = (item: Record<string, any>, key: string) => {
    const classes: Record<string, boolean> = {
        'icon-option-default': true,
    };
    if (isSubmite.value) {
        classes['icon-option-right'] = item.answer === `option_${key}`;
        classes['icon-option-error'] = item.history_answer === `option_${key}` && item.answer !== item.history_answer && item.history_answer;
    } else {
        classes['icon-option-select'] = item.history_answer === `option_${key}`;
    }
    return classes;
};
const getQuestionList = async() => {
    const res = await apiQuestionList();
    const { question, follow, } = res;
    const { list, status, } = question || {};
    questionList.value = list || [];
    isSubmite.value = status === '1';
    selectKeyList = Array(list.length).fill('');
    store.setIsAnswered(status === '1');
    store.setFollowList(follow);
};
getQuestionList();

const onShowGourd = () => {
    store.setPopStatus('view', true);
};

defineExpose({
    refresh: getQuestionList,
});
</script>
<style lang="scss" scoped>
.answer-module {
    padding-top: 100px;
    position: relative;
    min-height: 1768px; // 上下背景的最小高度， 中间循环平铺
    background: url('@/assets/images/bg/bg_img_3@3x.jpg') no-repeat, url('@/assets/images/bg/bg_img_4@3x.jpg') repeat;
    background-size: 100% 958px, 100% 80%;
}

.zindex2 {
    position: relative;
    z-index: 2;
}

.answer-title {
    margin-bottom: 130px;
}

.answer-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
}

.list-item {
    padding-left: 94px;
    margin-bottom: 28px;
    &-title {
        padding-right: 94px;
        font-weight: bold;
        font-size: 30px;
        color: #67492f;
        line-height: 42px;
        margin-bottom: 28px;
    }
}

.title-text {
    font-size: 32px;
    color: #ebf5ff;
    line-height: 60px;
    text-align: center;

    &-top {
        margin-top: -16px;
    }

    &-mark {
        text-decoration: underline;
        color: #c6d7fa;
        margin-right: -10px;
    }
}

.option-item {
    width: 260px;
    margin-right: 24px;
    margin-bottom: 20px;
    overflow: hidden;
    --option-item-bg: #fffaf4;
    --option-item-border: #eedcc2;
    --sort-bg: #fcead1;
    --sort-border: rgba(251, 236, 216, 0.5);
    background: var(--option-item-bg);
    border: 2px solid var(--option-item-border);
    padding-right: 8px;
    &-error {
        --option-item-border: #eec2c2;
        --option-item-bg: #fff4f4;
        --sort-bg: #fcd1d1;
        --sort-border: rgba(251, 216, 216, 0.5);
    }
    &-right {
        --option-item-border: #e7eec2;
        --sort-bg: #eafcd1;
        --sort-border: rgba(244, 251, 216, 0.5);
    }

    &-sort {
        width: 40px;
        background-color: var(--sort-bg);
        padding-left: 10px;
        line-height: 60px;
        position: relative;
        color: #76573a;
        &::before {
            content: '';
            position: absolute;
            top: -30px;
            left: 40px;
            width: 0;
            height: 0;
            border-top: 60px solid transparent;
            border-bottom: 60px solid transparent;
            border-left: 16px solid var(--sort-bg);
            z-index: 2;
        }
        &:after {
            content: '';
            position: absolute;
            top: -30px;
            left: 45px;
            width: 0;
            height: 0;
            border-top: 60px solid transparent;
            border-bottom: 60px solid transparent;
            border-left: 16px solid var(--sort-border);
        }
    }

    &-text {
        margin-left: 32px;
        color: #76573a;
    }
    &-icon {
        margin-left: auto;
    }
}

.answer-btn {
    margin: 30px auto 0;
    font-weight: bold;
    font-size: 28px;
    color: #a9582f;
    line-height: 1;
}

.answer-tip {
    margin-top: 16px;
    font-size: 20px;
    color: rgba(103, 73, 47, 0.6);
    line-height: 28px;
    text-align: center;
}
</style>
